import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.css']
})
export class ControlComponent implements OnInit {

  mediator: string = "MEDIATOR TYPE";

  constructor() { }

  ngOnInit() {
  }

  setMediator(type: string) {
    // console.log(type);
    this.mediator = type;
    document.getElementById('list-sel-list').classList.add('disabled');
    document.getElementById('list-conf-list').classList.remove('disabled');
    document.getElementById('list-conf-list').click();
  }

  resetPage() {
    this.mediator = "MEDIATOR TYPE";
    document.getElementById('list-sel-list').classList.remove('disabled');
    document.getElementById('list-conf-list').classList.add('disabled');    
    document.getElementById('list-out-list').classList.add('disabled');
    document.getElementById('list-sel-list').click();    
  }
  
}



// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/control/control.component.ts